import * as React from "react";
import styled from "styled-components";

import { media } from "../../common/utils/style";
import { Image } from "../entities";
import S3Uploader from "../../lib/S3Uploader";
import Translate from "../../common/components/Translate";
import { BlurredLazyImage } from "../../common/components/lazy";
import Icon from "../../common/components/Icon";
import Hover from "../../common/components/Hover";

interface Props {
  image?: Image;
  editable?: boolean;
  uploader?: S3Uploader;
}

const CoverImage: React.SFC<Props> = props => {
  const { image, editable, uploader } = props;
  if (!editable && !image) {
    return null;
  }
  return (
    <Hover>
      {({ isHovered, ref }) => (
        <Base innerRef={ref}>
          {image && <StyledImage image={image} size="1280x400#" background lazy={false} />}
          {editable &&
            (image ? (
              <>
                <Overlay
                  isHovered={isHovered}
                  onClick={e => {
                    e.preventDefault();
                    uploader!.choose();
                  }}
                >
                  <OverlayContent>
                    <OverlayIcon name="wt-icon-camera-o-2" />
                    <OverlayText>
                      <Translate id="company.edit_cover_image" />
                    </OverlayText>
                    <OverlaySubText>
                      <Translate id="company.cover_image_recommended_size" />
                    </OverlaySubText>
                  </OverlayContent>
                </Overlay>
                {/* TODO(kdnk): Comment in when you implement popup */}
                {/* {this.state.openBackgroundPopup && <ImageUploadPopup uploader={this.avatarUploader} />} */}
                <input {...uploader!.getPropsForInput()} style={{ display: "none" }} />
              </>
            ) : (
              <>
                <Placeholder
                  onClick={e => {
                    e.preventDefault();
                    uploader!.choose();
                  }}
                >
                  <PlaceholderContent>
                    <PlaceholderButton>
                      <PlaceholderIcon name="wt-icon-camera-o-2" />
                      <PlaceholderText>
                        <Translate id="company.add_cover_image" />
                      </PlaceholderText>
                    </PlaceholderButton>
                    <PlaceholderSubText>
                      <Translate id="company.cover_image_recommended_size" />
                    </PlaceholderSubText>
                  </PlaceholderContent>
                </Placeholder>
                <input {...uploader!.getPropsForInput()} style={{ display: "none" }} />
              </>
            ))}
        </Base>
      )}
    </Hover>
  );
};

const Base = styled.div`
  width: 100%;
  height: 300px;
  @media ${media.large} {
    height: 400px;
  }
`;

const StyledImage = styled(BlurredLazyImage)`
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
`;

interface OverlayStyleProps {
  isHovered: boolean;
}

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
  visibility: ${(props: OverlayStyleProps) => (props.isHovered ? "visible" : "hidden")};
  opacity: ${(props: OverlayStyleProps) => (props.isHovered ? 1 : 0)};
  transition: all 200ms ease-out;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding-top: 35px;
`;

const OverlayIcon = styled(Icon)`
  font-size: 45px;
`;

const OverlayText = styled.div`
  margin-top: 15px;
  font-size: 22px;
`;

const OverlaySubText = styled.div`
  margin-top: 12px;
  font-size: 13px;
`;

const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, #ffffff, #fafafa);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
`;

const PlaceholderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 35px;
  color: rgba(0, 0, 0, 0.4);
`;

const PlaceholderButton = styled.div`
  height: 60px;
  border-radius: 100px;
  border: dashed 1px rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 45px;
`;

const PlaceholderIcon = styled(Icon)`
  font-size: 22px;
  margin-top: -2px;
`;

const PlaceholderText = styled.div`
  margin-left: 15px;
  font-size: 17px;
`;

const PlaceholderSubText = styled.span`
  margin-top: 20px;
  font-size: 13px;
  line-height: 1;
  text-align: center;
`;

export default CoverImage;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/CoverImage.tsx